import { render, staticRenderFns } from "./havayollaritumlistecomp.vue?vue&type=template&id=04faaf7a"
import script from "./havayollaritumlistecomp.vue?vue&type=script&lang=js"
export * from "./havayollaritumlistecomp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports